import React, { Component, Fragment } from 'react'
import { Badge, Button, message, Tooltip } from 'antd'
import _, { get, pick } from 'lodash'
import { filterCheckedColumns, sessionItemVal } from '../../../modules/Utils'
import Suppliers from '../../../api/Purchase/Suppliers'
import Dropdowns from '../../../api/Dropdowns'
import ContractsApi from '../../../api/Purchase/PurchaseContracts'
import { Link, withRouter } from 'react-router-dom'
import CustomTable from '../../../elements/Table/CustomTable'
import State from '../../../elements/State'
import Status from '../../../elements/Status'
import { compose } from 'recompose'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import BoolFilter from '../../../elements/Select/BoolFilter'
import BoolCell from '../../../elements/Table/Cells/BoolCell'

const NewContractButton = withRouter(({ history, supplier, member }) => {
  return (
    <Button
      type="primary"
      icon={'plus'}
      onClick={() => {
        history.push({
          pathname: 'contracts/new',
          state: { supplier, member },
        })
      }}>
      New{' '}
    </Button>
  )
})

class ContractsCmp extends Component {
  constructor(props) {
    super(props)
    this.api = new Suppliers()
    this.contractApi = new ContractsApi()
    this.dropdownApi = new Dropdowns()
    this.key = props.supplier._key
    this.state = {
      key: '',
      contracts: [],
      fetching: false,
    }
  }

  columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => (
        <div>
          {original.default === true && (
            <Tooltip placement="top" title="Default Contract">
              <Badge
                dot
                style={{
                  background: '#2db731',
                }}
              />
            </Tooltip>
          )}
          <Link
            to={{
              pathname: `contracts/${original._key}/view`,
              state: {
                contract: original,
                supplier: this.props.supplier,
                member: this.props.member,
              },
            }}
            style={{ marginLeft: '10px' }}>
            {value}
          </Link>
        </div>
      ),
    },
    {
      Header: 'Type',
      accessor: 'type',
      Cell: ({ value }) => _.upperFirst(value),
      hideable: true,
    },
    {
      Header: 'Default',
      accessor: 'default',
      hideable: true,
      hideDefault: false,
      filterMethod: filterCheckedColumns,
      Filter: BoolFilter,
      Cell: BoolCell,
    },
    {
      Header: 'Title',
      accessor: 'title',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
    },
    {
      Header: 'Services State',
      accessor: 'state',
      Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
    },
    {
      Header: 'Billing State',
      accessor: 'billingState',
      Cell: ({ value }) => value && <State value={sessionItemVal('general_state_dropdown', value)} tooltip={false} />,
    },
    {
      Header: 'Document Status',
      accessor: 'status',
      Cell: ({ value }) => <Status value={value} tooltip={false} />,
    },
  ]

  componentDidMount = async () => {
    await this.fetch()
  }

  fetch = async () => {
    try {
      console.log(567, this.props)
      this.setState({ fetching: true })
      const contracts = await this.contractApi.listWithOwner(
        get(this.props, 'supplier.owner', '').replace('members/', '')
      )
      contracts.sort(function (x, y) {
        return x.status === 'Approved' ? -1 : y.status === 'Approved' ? 1 : 0
      })
      const primaryContract = contracts.filter((c) => c.default === true)[0] || {}
      this.setState({
        contracts,
        primaryContract,
        fetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
      })
    }
  }

  render() {
    const { supplier, member } = this.props
    return (
      <Fragment>
        <CustomTable
          CreateButton={() => <NewContractButton supplier={supplier} member={member} />}
          fetch={this.fetch}
          loading={this.state.fetching}
          columns={this.columns}
          data={this.state.contracts}
          pagination={false}
        />
      </Fragment>
    )
  }
}

export default compose(withLoadingSection, withRouter)(ContractsCmp)
